import * as React from 'react'
import * as PropTypes from 'prop-types'
import Input from '@material-ui/core/Input'
import { withStyles } from '@material-ui/core/styles'
import { DataTypeProvider } from '@devexpress/dx-react-grid'
import conformToMask from '../Form/conformToMask'

const styles = {
  input: {
    textAlign: 'left',
    width: '100%'
  }
}

const phoneNumberMask = [
  '(',
  /[1-9]/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d|-/,
  /\d|-/,
  /\d/,
  /\d/,
  /\d/,
  /\d/
]

const getInputValue = value => {
  if (!value) return ''
  return conformToMask(value.replace('+55', ''), phoneNumberMask, {
    guide: false
  }).conformedValue
}

const Formatter = ({ value }) => getInputValue(value)

const EditorBase = ({ value, onValueChange, classes }) => {
  const handleChange = event => {
    const { value: targetValue } = event.target
    if (targetValue === '') {
      onValueChange()
      return
    }
    const digits = targetValue.replace(/\D/g, '')
    onValueChange(`+55${digits}`)
  }
  return (
    <Input
      classes={{
        input: classes.input
      }}
      fullWidth
      value={getInputValue(value)}
      onChange={handleChange}
    />
  )
}

EditorBase.propTypes = {
  value: PropTypes.string,
  onValueChange: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired
}

EditorBase.defaultProps = {
  value: undefined
}

const Editor = withStyles(styles)(EditorBase)

const availableFilterOperations = [
  'equal',
  'notEqual',
  'greaterThan',
  'greaterThanOrEqual',
  'lessThan',
  'lessThanOrEqual'
]

const PhoneTypeProvider = props => (
  <DataTypeProvider
    formatterComponent={Formatter}
    editorComponent={Editor}
    availableFilterOperations={availableFilterOperations}
    {...props}
  />
)

export default PhoneTypeProvider
